<template>
  <div ref="domRef" class="base-card-info">
    <div class="info-card-title">
      法人信息
    </div>
    <div class="base-info-list">
      <div class="left-list gap-y-[14px]">
        <div class="item">
          <div class="label">
            法定代表人姓名
          </div>
          <div class="value">
            {{ baseInfo.serverLegal?.legalName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            法定代表人电话
          </div>
          <div class="value">
            {{ baseInfo.serverLegal?.legalPhone }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            身份证人像面
          </div>
          <div class="value">
            <div class="id-card-box">
              <img
                :src="baseInfo.serverLegal?.idNoFrontUrl"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right-list">
        <div class="item">
          <div class="label">
            法定代表人证件号
          </div>
          <div class="value">
            {{ baseInfo.serverLegal?.legalIdNo }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            证件有效期
          </div>
          <div class="value">
            <span>{{ baseInfo.serverLegal?.idNoExpiryStartDate }}</span>
            <span> ~ </span>
            <span>{{ baseInfo.serverLegal?.idNoExpiryEndDate }}&nbsp;&nbsp;</span>
            <span v-if="['29991231', '2999-12-31'].includes(baseInfo.serverLegal?.idNoExpiryEndDate)">长期</span>
          </div>
        </div>
        <div class="item">
          <div class="label">
            身份证国徽面
          </div>
          <div class="value">
            <div class="id-card-box">
              <img
                :src="baseInfo.serverLegal?.idNoBackUrl"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IServerMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';

defineOptions({ name: 'LegalPersonInfo' }); // 账户中心 - 法人信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const baseInfo = inject('baseInfo') as IServerMergeInfo;
</script>
